/* GROCERA · ca aplicația — rândurile de recomandări (13.10.2026)
   Trei rânduri sub produs, în ordinea de pe site-ul nou (grocera-web):
     1. „Mai multe de la [brand]” / „De la același furnizor”  — vendor + custom.acelasi_furnizor, amestecate 1:1, max 16
     2. „Ce credem noi că merge bine”                          — lista de potriviri + căutarea magazinului, max 12
     3. „Produse similare”                                     — recomandările Shopify (intent related), max 12
   Totul se încarcă lenes, după ce pagina e afișată. Un rând fără produse dispare complet.
   Cardurile sunt ale temei, aduse prin sections/ga-reco-carduri.liquid. */
(function () {
  'use strict';

  /* ——— Lista de potriviri (titlu → cuvinte de căutat) ——— */
  var POTRIVIRI = [
    [['spanac', 'rucola', 'valerian', 'salat', 'verdetur', 'lollo', 'iceberg'], ['branza feta', 'ulei de masline', 'rosii cherry', 'nuci', 'otet balsamic', 'parmezan']],
    [['rosii', 'tomate'], ['mozzarella', 'busuioc', 'ulei de masline', 'telemea', 'ceapa rosie', 'castraveti']],
    [['castrave'], ['iaurt grecesc', 'marar', 'rosii', 'telemea', 'ceapa verde']],
    [['avocado'], ['lime', 'rosii cherry', 'oua', 'paine integrala', 'somon afumat', 'nachos']],
    [['cartof'], ['smantana', 'unt', 'rozmarin', 'usturoi', 'cascaval', 'bacon']],
    [['ciuperc', 'champignon', 'pleurotus'], ['smantana', 'usturoi', 'patrunjel', 'paste', 'unt', 'cascaval']],
    [['ardei'], ['telemea', 'carne tocata', 'orez', 'rosii', 'smantana']],
    [['dovlec', 'vinete', 'zucchin'], ['usturoi', 'rosii', 'ulei de masline', 'branza feta', 'iaurt grecesc']],
    [['ceapa', 'usturoi'], ['ulei de masline', 'rosii', 'carne tocata', 'cartofi', 'unt']],
    [['morcov', 'telina', 'patrunjel', 'pastarnac'], ['piept de pui', 'cartofi', 'ceapa', 'smantana', 'unt']],
    [['coriandru', 'busuioc', 'arpagic', 'chives', 'chivas', 'marar', 'menta', 'cimbru', 'rozmarin', 'oregano', 'tarhon', 'leustean', 'microplante', 'microgreens'], ['rosii', 'ulei de masline', 'lamaie', 'branza feta', 'avocado', 'piept de pui']],
    [['varza', 'broccoli', 'conopida'], ['smantana', 'cascaval', 'bacon', 'carnati', 'usturoi']],
    [['banan'], ['fulgi de ovaz', 'unt de arahide', 'iaurt', 'miere', 'ciocolata', 'lapte']],
    [['mere', 'mar'], ['scortisoara', 'unt de arahide', 'nuci', 'cheddar', 'miere']],
    [['afine', 'zmeur', 'capsun', 'mur', 'mure', 'fructe de padure', 'coacaz'], ['iaurt grecesc', 'frisca', 'granola', 'mascarpone', 'miere', 'inghetata']],
    [['lamai', 'lime', 'portocal', 'grapefruit', 'mandarin', 'citric'], ['ghimbir', 'miere', 'apa minerala', 'ceai', 'apa tonica']],
    [['strugur'], ['branza brie', 'gorgonzola', 'nuci', 'vin alb', 'prosciutto']],
    [['pepene', 'piersic', 'nectarin', 'caise', 'prun', 'para', 'pere', 'kiwi', 'mango', 'ananas', 'rodi'], ['iaurt', 'inghetata', 'frisca', 'granola', 'prosciutto']],
    [['piept de pui', 'pulpe', 'aripi', 'pui', 'curcan'], ['orez', 'cartofi', 'legume congelate', 'boia', 'usturoi', 'smantana']],
    [['porc', 'ceafa', 'cotlet', 'costit', 'muschi'], ['mustar', 'cartofi', 'varza', 'muraturi', 'bere']],
    [['vita', 'vitel', 'antricot', 'steak', 'burger'], ['vin rosu', 'cartofi', 'rozmarin', 'unt', 'ciuperci', 'piper']],
    [['tocat', 'mici', 'chiftel'], ['mustar', 'paine', 'ceapa', 'rosii', 'paste', 'bere']],
    [['somon', 'ton', 'dorad', 'pastrav', 'biban', 'cod', 'peste'], ['lamaie', 'marar', 'orez', 'vin alb', 'sparanghel', 'unt']],
    [['crevet', 'fructe de mare', 'calamar', 'midii'], ['usturoi', 'lamaie', 'paste', 'vin alb', 'unt']],
    [['prosciutto', 'jamon', 'serrano', 'parma'], ['pepene', 'mozzarella', 'rucola', 'vin', 'grisine']],
    [['salam', 'sunca', 'parizer', 'bacon', 'cabanos', 'carnat', 'kaizer', 'pastram'], ['cascaval', 'paine', 'masline', 'muraturi', 'mustar', 'oua']],
    [['telemea', 'feta', 'branza de burduf', 'cas'], ['rosii', 'castraveti', 'masline', 'ardei', 'malai', 'paine']],
    [['cascaval', 'cheddar', 'gouda', 'edam', 'emmental'], ['paine', 'sunca', 'unt', 'rosii', 'struguri']],
    [['mozzarella', 'burrata'], ['rosii', 'busuioc', 'ulei de masline', 'prosciutto', 'pesto']],
    [['parmezan', 'grana', 'pecorino'], ['paste', 'ulei de masline', 'rucola', 'pesto', 'vin']],
    [['brie', 'camembert', 'gorgonzola', 'roquefort'], ['vin', 'struguri', 'nuci', 'miere', 'crackers']],
    [['ricotta', 'mascarpone', 'cottage', 'branza proaspata', 'crema de branza'], ['fructe de padure', 'miere', 'paine', 'somon afumat', 'biscuiti']],
    [['iaurt', 'kefir', 'sana', 'chefir'], ['granola', 'miere', 'fructe de padure', 'banane', 'nuci']],
    [['lapte'], ['cereale', 'cafea', 'cacao', 'fulgi de ovaz', 'biscuiti']],
    [['oua', 'ou'], ['bacon', 'paine', 'unt', 'cascaval', 'rosii', 'spanac']],
    [['unt', 'margarin'], ['paine', 'gem', 'miere', 'faina']],
    [['smantan'], ['cartofi', 'malai', 'marar', 'ciuperci']],
    [['frisca'], ['capsuni', 'fructe de padure', 'cafea', 'inghetata']],
    [['croissant', 'cornulet', 'pain au', 'briose', 'patiserie'], ['cafea', 'gem', 'unt', 'ciocolata', 'lapte']],
    [['paine', 'bagheta', 'franzela', 'chifl', 'lipii', 'tortilla'], ['unt', 'gem', 'cascaval', 'sunca', 'humus', 'rosii']],
    [['paste', 'spaghet', 'penne', 'fusilli', 'tagliatelle', 'lasagn', 'macaroane'], ['sos de rosii', 'parmezan', 'pesto', 'usturoi', 'ulei de masline', 'busuioc']],
    [['orez', 'risotto'], ['piept de pui', 'sos de soia', 'legume congelate', 'curry', 'ciuperci']],
    [['faina', 'drojdie'], ['drojdie', 'zahar', 'oua', 'unt', 'lapte']],
    [['malai', 'mamalig', 'gris'], ['telemea', 'smantana', 'oua', 'lapte']],
    [['sos de rosii', 'passata', 'pulpa de rosii', 'bulion'], ['paste', 'parmezan', 'busuioc', 'carne tocata']],
    [['ketchup', 'maionez', 'mustar', 'sos gratar', 'bbq'], ['cartofi pai', 'mici', 'carnati', 'paine burger']],
    [['conserva de ton', 'conserva ton', 'ton in'], ['porumb', 'maioneza', 'paste', 'lamaie']],
    [['masline', 'capere'], ['branza feta', 'ulei de masline', 'rosii', 'prosciutto']],
    [['ulei de masline', 'otet'], ['rucola', 'rosii', 'paine', 'mozzarella']],
    [['miere'], ['ceai', 'iaurt', 'nuci', 'lamaie']],
    [['gem', 'dulceata', 'unt de arahide', 'crema de alune'], ['paine', 'unt', 'clatite', 'banane']],
    [['humus', 'hummus'], ['lipii', 'morcovi', 'castraveti', 'ardei']],
    [['tofu', 'tempeh', 'plant', 'vegan'], ['sos de soia', 'orez', 'ghimbir', 'legume']],
    [['cafea', 'espresso', 'capsule'], ['lapte', 'frisca', 'biscuiti', 'croissant', 'ciocolata']],
    [['ceai'], ['miere', 'lamaie', 'ghimbir', 'biscuiti']],
    [['cereale', 'musli', 'granola', 'fulgi'], ['lapte', 'iaurt', 'banane', 'fructe de padure']],
    [['ciocolat', 'praline', 'bomboan'], ['cafea', 'capsuni', 'nuci', 'vin rosu']],
    [['biscuit', 'napolitan', 'fursec'], ['lapte', 'cafea', 'ceai', 'ciocolata']],
    [['chips', 'nachos', 'covrig', 'pufulet', 'popcorn', 'crackers', 'snack'], ['bere', 'sos', 'cola', 'alune']],
    [['alune', 'nuci', 'migdale', 'caju', 'fistic', 'seminte'], ['miere', 'iaurt', 'fructe uscate', 'ciocolata']],
    [['inghetat'], ['fructe de padure', 'frisca', 'biscuiti', 'topping']],
    [['vin rosu', 'merlot', 'cabernet', 'feteasca neagra', 'pinot noir'], ['brie', 'carne de vita', 'ciocolata neagra', 'prosciutto', 'nuci']],
    [['vin alb', 'vin roze', 'rose', 'spumant', 'prosecco', 'sauvignon', 'chardonnay', 'riesling'], ['somon', 'branza brie', 'fructe de mare', 'capsuni']],
    [['bere', 'cidru'], ['chipsuri', 'alune', 'mici', 'covrigei', 'carnati']],
    [['gin', 'vodka', 'whisky', 'rom', 'lichior', 'tequila', 'coniac'], ['apa tonica', 'lime', 'cola', 'suc de portocale']],
    [['apa tonica', 'tonic'], ['gin', 'lime', 'lamaie']],
    [['apa minerala', 'apa plata', 'carbogazoas'], ['lamaie', 'lime', 'menta', 'ghimbir']],
    [['suc', 'limonad', 'cola', 'fanta', 'energizant', 'racoritoare'], ['chipsuri', 'pizza', 'covrigei']],
    [['pizza'], ['bere', 'cola', 'rucola', 'parmezan']],
    [['legume congelate', 'mix de legume', 'mazare', 'fasole verde'], ['piept de pui', 'orez', 'unt', 'smantana']],
    [['cartofi prajiti', 'cartofi congelati'], ['ketchup', 'maioneza', 'mici', 'burger']],
    [['detergent'], ['balsam de rufe', 'solutie pete', 'capsule']],
    [['sampon'], ['balsam de par', 'gel de dus']],
    [['pasta de dinti', 'periuta'], ['apa de gura', 'ata dentara', 'periuta']],
    [['scutec'], ['servetele umede', 'crema']],
    [['hartie igienica', 'prosop'], ['servetele', 'solutie de curatat']]
  ];

  var MAX_SURSA = 16;
  var MAX_BINE = 12;
  var MAX_SIMILARE = 12;

  /* ——— unelte ——— */
  function fara(s) {
    return (s || '')
      .toLowerCase()
      .replace(/ă|â|à|á|ä/g, 'a')
      .replace(/î|í|ì|ï/g, 'i')
      .replace(/ș|ş/g, 's')
      .replace(/ț|ţ/g, 't')
      .replace(/é|è|ë/g, 'e')
      .replace(/ó|ò|ö/g, 'o')
      .replace(/ú|ù|ü/g, 'u')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Câștigă potrivirea care prinde cea mai lungă bucată; la egalitate, regula de mai sus.
  function potrivire(text) {
    var t = fara(text), best = null;
    for (var i = 0; i < POTRIVIRI.length; i++) {
      var chei = POTRIVIRI[i][0];
      for (var j = 0; j < chei.length; j++) {
        var k = chei[j];
        if (t.indexOf(k) !== -1 && (!best || k.length > best.len)) best = { len: k.length, cuvinte: POTRIVIRI[i][1] };
      }
    }
    return best ? best.cuvinte : null;
  }

  function json(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function text(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  }

  // primele N produse pe stoc pentru un cuvânt
  function cauta(cuvant, n) {
    var u = '/search/suggest.json?q=' + encodeURIComponent(cuvant) +
      '&resources[type]=product&resources[limit]=' + n +
      '&resources[options][unavailable_products]=hide';
    return json(u).then(function (d) {
      var p = (d && d.resources && d.resources.results && d.resources.results.products) || [];
      return p.filter(function (x) { return x.available !== false; }).map(function (x) { return String(x.id); });
    }).catch(function () { return []; });
  }

  // două ture: în fiecare tură, primul produs nefolosit din fiecare cuvânt
  function doua_ture(liste, exclude, max) {
    var ales = [], vazut = {};
    (exclude || []).forEach(function (id) { vazut[String(id)] = true; });
    for (var tura = 0; tura < 2 && ales.length < max; tura++) {
      for (var i = 0; i < liste.length && ales.length < max; i++) {
        var l = liste[i];
        for (var j = 0; j < l.length; j++) {
          if (!vazut[l[j]]) { vazut[l[j]] = true; ales.push(l[j]); break; }
        }
      }
    }
    return ales;
  }

  function amesteca(a, b, exclude, max) {
    var out = [], vazut = {}, i = 0;
    (exclude || []).forEach(function (id) { vazut[String(id)] = true; });
    while (out.length < max && (i < a.length || i < b.length)) {
      [a[i], b[i]].forEach(function (id) {
        if (id && !vazut[id] && out.length < max) { vazut[id] = true; out.push(id); }
      });
      i++;
    }
    return out;
  }

  /* ——— cardurile temei, în ordinea noastră ——— */
  function carduri(ids) {
    if (!ids.length) return Promise.resolve([]);
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var u = '/search?type=product&options[unavailable_products]=hide&section_id=ga-reco-carduri&q=' + encodeURIComponent(q);
    return text(u).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var dupa = {};
      d.querySelectorAll('[data-pid]').forEach(function (el) { dupa[el.getAttribute('data-pid')] = el; });
      return ids.map(function (id) { return dupa[id]; }).filter(Boolean);
    }).catch(function () { return []; });
  }

  /* ——— un rând ——— */
  function umple(rand, ids) {
    if (!ids || !ids.length) { rand.remove(); return; }
    carduri(ids).then(function (noduri) {
      if (!noduri.length) { rand.remove(); return; }
      var pista = rand.querySelector('[data-ga-reco-pista]');
      noduri.forEach(function (n) { pista.appendChild(n); });
      rand.hidden = false;
      sageti(rand, pista);
    });
  }

  function sageti(rand, pista) {
    var prev = rand.querySelector('[data-ga-reco-prev]');
    var next = rand.querySelector('[data-ga-reco-next]');
    if (!prev || !next) return;
    function stare() {
      var are = pista.scrollWidth - pista.clientWidth > 4;
      prev.hidden = !are || pista.scrollLeft <= 4;
      next.hidden = !are || pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 4;
    }
    function muta(semn) { pista.scrollBy({ left: semn * Math.round(pista.clientWidth * 0.9), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { muta(-1); });
    next.addEventListener('click', function () { muta(1); });
    pista.addEventListener('scroll', stare, { passive: true });
    window.addEventListener('resize', stare);
    stare();
  }

  /* ——— produs ——— */
  function produs(gazda) {
    var id = gazda.dataset.gaRecoProdus;
    var vendor = gazda.dataset.gaRecoVendor || '';
    var titlu = gazda.dataset.gaRecoTitlu || '';
    var tip = gazda.dataset.gaRecoTip || '';
    var colectii = gazda.dataset.gaRecoColectii || '';
    var furnizor = (gazda.dataset.gaRecoFurnizor || '').split(',').filter(Boolean);
    var randuri = {
      sursa: gazda.querySelector('[data-ga-reco="sursa"]'),
      bine: gazda.querySelector('[data-ga-reco="bine"]'),
      similare: gazda.querySelector('[data-ga-reco="similare"]')
    };

    /* 1 — producător + furnizor */
    if (randuri.sursa) {
      var cerere = (vendor && fara(vendor) !== 'grocera')
        ? text('/collections/vendors?q=' + encodeURIComponent(vendor) + '&section_id=ga-produse-id')
          .then(function (html) {
            var m = html.match(/data-ga-produse-id="([^"]*)"/);
            return m ? m[1].split(',').filter(Boolean).slice(0, 24) : [];
          }).catch(function () { return []; })
        : Promise.resolve([]);
      cerere.then(function (a) {
        umple(randuri.sursa, amesteca(a, furnizor.slice(0, 24), [id], MAX_SURSA));
      });
    }

    /* 2 — ce merge bine */
    if (randuri.bine) {
      var cuvinte = potrivire(titlu) || potrivire(tip + ' ' + colectii);
      if (!cuvinte) randuri.bine.remove();
      else Promise.all(cuvinte.map(function (c) { return cauta(c, 4); })).then(function (liste) {
        umple(randuri.bine, doua_ture(liste, [id], MAX_BINE));
      });
    }

    /* 3 — produse similare */
    if (randuri.similare) {
      json('/recommendations/products.json?product_id=' + id + '&limit=' + MAX_SIMILARE + '&intent=related')
        .then(function (d) {
          var p = (d && d.products) || [];
          return p.filter(function (x) { return x.available !== false; }).map(function (x) { return String(x.id); });
        })
        .catch(function () { return []; })
        .then(function (ids) { umple(randuri.similare, ids.slice(0, MAX_SIMILARE)); });
    }
  }

  /* ——— coș ——— */
  function cos(gazda) {
    var rand = gazda.querySelector('[data-ga-reco="bine"]');
    if (!rand) return;
    var inCos = (gazda.dataset.gaRecoCosIds || '').split(',').filter(Boolean);
    var titluri = [];
    try { titluri = JSON.parse(gazda.dataset.gaRecoCosTitluri || '[]'); } catch (e) { titluri = []; }
    if (!titluri.length) { rand.remove(); return; }

    var cuvinte = [], vazut = {};
    titluri.forEach(function (t) {
      var c = potrivire(t);
      if (c) c.forEach(function (x) { if (!vazut[x]) { vazut[x] = true; cuvinte.push(x); } });
    });
    if (!cuvinte.length) { rand.remove(); return; }

    Promise.all(cuvinte.slice(0, 12).map(function (c) { return cauta(c, 4); })).then(function (liste) {
      umple(rand, doua_ture(liste, inCos, MAX_BINE));
    });
  }

  /* ——— pornire lenesă ——— */
  function porneste(gazda) {
    if (gazda.dataset.gaRecoPornit) return;
    gazda.dataset.gaRecoPornit = '1';
    if (gazda.dataset.gaRecoCosIds !== undefined) cos(gazda); else produs(gazda);
  }

  function lenes() {
    document.querySelectorAll('[data-ga-reco-gazda]').forEach(function (g) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (intrari) {
          intrari.forEach(function (i) { if (i.isIntersecting) { io.disconnect(); porneste(g); } });
        }, { rootMargin: '600px 0px' });
        io.observe(g);
      } else porneste(g);
    });
  }

  if (document.readyState === 'complete') lenes();
  else window.addEventListener('load', lenes);
  document.addEventListener('shopify:section:load', lenes);
})();
